import { Button } from "antd";
import React from "react";
import { t } from "i18next";

export const addresseItemMapsInputs = ({
  location = "",
  maps,
  changeEdition = null,
}) => {
  const inputs = [
    {
      children: [
        {
          name: "location",
          label: t("addresseItemMapsInputs.locationLabel"),
          value: location,
          required: true,
          type: "input",
          col: 24,
        },
        {
          required: true,
          label: t("addresseItemMapsInputs.realAddressLabel"),
          name: "maps",
          value: maps,
          type: "google-adress",
          col: 24,
        },
      ],
    },
  ];

  if (changeEdition !== null) {
    inputs[0].children.push({
      label: t("addresseItemMapsInputs.save"),
      type: "submit",
      size: "small",
    });

    inputs[0].children.push({
      type: "component",
      component: () => (
        <Button
          onClick={changeEdition}
          size={"small"}
          type={"primary"}
          style={{ marginRight: 10 }}
        >
          {t("addresseItemMapsInputs.cancel")}
        </Button>
      ),
    });
  }

  return inputs;
};
